import { render } from "./FUploadImageBm.vue?vue&type=template&id=06862bbd&scoped=true"
import script from "./FUploadImageBm.vue?vue&type=script&lang=js"
export * from "./FUploadImageBm.vue?vue&type=script&lang=js"

import "./FUploadImageBm.vue?vue&type=style&index=0&id=06862bbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06862bbd"]])

export default __exports__